import { useTranslation } from "react-i18next";

const AddressHeader = ({
  onSort,
  sortByField,
  orderSortByField,
  addressColumnLabel,
  variant = "default",
}) => {
  const { t } = useTranslation();
  const isSettingsList = variant === "settings";
  const addressLabel = addressColumnLabel ?? t("Address");

  const handleSort = (field) => {
    if (onSort) {
      // Si on clique sur la même colonne, on alterne l'ordre
      if (sortByField === field) {
        onSort(field, orderSortByField === "1" ? "-1" : "1");
      } else {
        // Sinon, on trie par défaut en croissant
        onSort(field, "1");
      }
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      // Affiche la flèche correspondant à l'ordre actuel
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    // Par défaut, affiche les deux flèches superposées
    return "fa-sort";
  };

  return (
    <div className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("name")}
        onKeyDown={(e) => e.key === "Enter" && handleSort("name")}
        role="button"
        tabIndex={0}
      >
        {t("Name")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("name")}`} aria-hidden />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("role")}
        onKeyDown={(e) => e.key === "Enter" && handleSort("role")}
        role="button"
        tabIndex={0}
      >
        {t("Role")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("role")}`} aria-hidden />
        </span>
      </div>
      {!isSettingsList && (
        <>
          <div
            className="table-standard-header-cell"
            style={{ cursor: "pointer" }}
            onClick={() => handleSort("city")}
            onKeyDown={(e) => e.key === "Enter" && handleSort("city")}
            role="button"
            tabIndex={0}
          >
            {addressLabel}
            <span className="sort-icon">
              <i className={`fas ${getSortIcon("city")}`} aria-hidden />
            </span>
          </div>
          <div className="table-standard-header-cell" />
        </>
      )}
    </div>
  );
};

export default AddressHeader;
